import { HalfCircleSpinner } from 'epic-spinners';
import { currencyFilter } from '@/utils/filters.js';

export default {
    name: 'ContractorData',
    props: {
        isMobile: Boolean,
        guest: Boolean,
        competition: Object,
        offer: {
            type: Object,
            default: () => {
                return {};
            }
        },
        subscription: {
            type: Object,
            default: () => {
                return {};
            }
        },
        quotationParticipating: Boolean,
        loader: Boolean,
        supplierDiscount: Number,
        calculateSupplierDiscount: Number,
        freeOffer: {
            type: Boolean,
            default: false
        }
    },
    components: {
        HalfCircleSpinner
    },
    data: () => ({
        tippyOptions: {
            arrow: false,
            placement: 'top'
        },
        show: false
    }),
    methods: {
        openSupplierDetails(id) {
            this.$emit('openSupplierDetails', id);
        },
        openContractorDetails() {
            this.$emit('openContractorDetails');
        },
        currencyFilter,
        guestOfferInteraction() {
            this.$emit('guestOfferInteraction');
        },
        supplierFirstInteraction() {
            this.$emit('supplierFirstInteraction');
        },
        openMyProposal() {
            this.$emit('openMyProposal');
        },
        goToOffers() {
            this.$router.push({ name: 'CompetitionDashboardGuest' })
        }
    },
    computed: {
        isEngelinkProduct() {
            return this.competition.nextSlot && this.competition.nextSlot.isProduct && this.quotationParticipating;
        },
        supplierList() {
            return this.competition.occupationSupplier;
        },
        cssProps() {
            return {
                '--justify-content': this.guest ? 'center' : 'space-between',
                '--margin-bottom': this.guest ? '0px' : '15px',
                '--margin-bottom-data': this.guest ? '0px' : '150px',
            };
        },
        sendProposal() {
            return this.competition.proposal != null ? true : false;
        }
    }
};
